import { ConnectionStatus } from 'api/partners/connectionStatus'
import { PartnerResource } from 'api/models'
import { Section, TableMobile } from 'components'
import SectionHeader from 'components/Section/SectionHeader'
import SectionTitle from 'components/Section/SectionTitle'
import { useIsMobile } from 'hooks'
import { useMemo } from 'react'

import { getToosConnectionColumns, getMobileToosConnectionColumns } from './columns'
import ToosTable from './ToosTable'

type Props = {
  partner: PartnerResource
  isLoading: boolean
  connectionStatuses: ConnectionStatus[]
  onRefresh: (connectionStatus: ConnectionStatus) => Promise<void>
  isRefreshing: string | null
}

const TOOS = ({ partner: _partner, isLoading, connectionStatuses, onRefresh, isRefreshing }: Props) => {
  const { isMobile } = useIsMobile()

  const toosConnectionColumns = useMemo(() => {
    return getToosConnectionColumns(onRefresh, isRefreshing)
  }, [onRefresh, isRefreshing])

  const mobileToosConnectionColumns = useMemo(() => {
    return getMobileToosConnectionColumns(onRefresh, isRefreshing)
  }, [onRefresh, isRefreshing])

  return (
    <Section>
      <SectionHeader>
        <SectionTitle>TOOS</SectionTitle>
      </SectionHeader>
      {isMobile ? (
        <TableMobile
          path={'./styles.ts'}
          columns={mobileToosConnectionColumns}
          rowKey='id'
          data={connectionStatuses}
          isLoading={isLoading}
        />
      ) : (
        <ToosTable
          columns={toosConnectionColumns}
          rowKey='id'
          data={connectionStatuses}
          isLoading={isLoading}
        />
      )}
    </Section>
  )
}

export default TOOS 